// všechny jména her zadávat v lowercase
export enum Esport {
    CS = "counter strike",
    LoL = "league of legends",
    KingsOfGlory = "kings of glory",
    Dota = "dota 2",
    Valorant = "valorant",
    EFotbal = "esoccer",
}
